/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetSimpleCrateDtoStatusEnum = {
    Archived: 'Archived',
    PendingReview: 'Pending Review',
    Draft: 'Draft',
    Published: 'Published'
};
/**
 * Check if a given object implements the GetSimpleCrateDto interface.
 */
export function instanceOfGetSimpleCrateDto(value) {
    if ((!('type' in value) && !('Type' in value)) || (value['type'] === undefined && value['Type'] === undefined))
        return false;
    if ((!('image' in value) && !('Image' in value)) || (value['image'] === undefined && value['Image'] === undefined))
        return false;
    if ((!('title' in value) && !('Title' in value)) || (value['title'] === undefined && value['Title'] === undefined))
        return false;
    if ((!('published' in value) && !('Published' in value)) || (value['published'] === undefined && value['Published'] === undefined))
        return false;
    if (!('modified' in value) || value['modified'] === undefined)
        return false;
    if ((!('hacker' in value) && !('Hacker' in value)) || (value['hacker'] === undefined && value['Hacker'] === undefined))
        return false;
    if ((!('category' in value) && !('Category' in value)) || (value['category'] === undefined && value['Category'] === undefined))
        return false;
    if (!('trackCount' in value) || value['trackCount'] === undefined)
        return false;
    if (!('viewCount' in value) || value['viewCount'] === undefined)
        return false;
    if (!('saveCount' in value) || value['saveCount'] === undefined)
        return false;
    if ((!('id' in value) && !('_id' in value)) || (value['id'] === undefined && value['_id'] === undefined))
        return false;
    return true;
}
export function GetSimpleCrateDtoFromJSON(json) {
    return GetSimpleCrateDtoFromJSONTyped(json, false);
}
export function GetSimpleCrateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['Type'],
        'image': json['Image'],
        'title': json['Title'],
        'published': (new Date(json['Published'])),
        'modified': (new Date(json['modified'])),
        'hacker': json['Hacker'],
        'category': json['Category'],
        'status': json['status'] == null ? undefined : json['status'],
        'trackCount': json['trackCount'],
        'viewCount': json['viewCount'],
        'saveCount': json['saveCount'],
        'id': json['_id'],
    };
}
export function GetSimpleCrateDtoToJSON(json) {
    return GetSimpleCrateDtoToJSONTyped(json, false);
}
export function GetSimpleCrateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Type': value['type'],
        'Image': value['image'],
        'Title': value['title'],
        'Published': value['published'].toISOString(),
        'modified': value['modified'].toISOString(),
        'Hacker': value['hacker'],
        'Category': value['category'],
        'status': value['status'],
        'trackCount': value['trackCount'],
        'viewCount': value['viewCount'],
        'saveCount': value['saveCount'],
        '_id': value['id'],
    };
}
